import React, { useState, useEffect } from 'react';
import logo from '../images/logo.png'; // Adjust path if needed
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useSpring, animated } from 'react-spring';

const Footer = () => {
  const [openSection, setOpenSection] = useState(null);

  // Toggle section function
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  // Spring animations for each section based on whether it's open or not
  const aboutSpring = useSpring({
    to: { maxHeight: openSection === 'about' ? '500px' : '0px', opacity: openSection === 'about' ? 1 : 0 },
    from: { maxHeight: '0px', opacity: 0 },
    config: { duration: 600 },
  });

  const contactSpring = useSpring({
    to: { maxHeight: openSection === 'contact' ? '500px' : '0px', opacity: openSection === 'contact' ? 1 : 0 },
    from: { maxHeight: '0px', opacity: 0 },
    config: { duration: 600 },
  });

  const agenciesSpring = useSpring({
    to: { maxHeight: openSection === 'agencies' ? '500px' : '0px', opacity: openSection === 'agencies' ? 1 : 0 },
    from: { maxHeight: '0px', opacity: 0 },
    config: { duration: 600 },
  });

  const loginSpring = useSpring({
    to: { maxHeight: openSection === 'login' ? '500px' : '0px', opacity: openSection === 'login' ? 1 : 0 },
    from: { maxHeight: '0px', opacity: 0 },
    config: { duration: 600 },
  });

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.gtranslate.net/widgets/latest/float.js';
    script.defer = true;
    document.body.appendChild(script);

    window.gtranslateSettings = {
      default_language: 'en',
      native_language_names: true,
      languages: ['en', 'fr'],
      wrapper_selector: '.gtranslate_wrapper',
      alt_flags: { en: 'usa' },
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <><div className="footer-container">
          <footer className="footer-content">
              {/* Large screen layout */}
              <div className="footer-large-layout">
                  {/* Left: Logo + site text + socials */}
                  <div className="footer-brand-large">
                      <Link to="/">
                          <img src={logo} alt="Site Logo" className="footer-logo" />
                      </Link>
                      <div className="footer-sitename">Vision Of An Eagle for Trustworthy Agencies</div>
                      <div className="footer-socials">
                          <a href="https://www.tiktok.com/@voeta.co?_t=ZT-8sIVHVs8qM6&_r=1" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
                          <a href="https://facebook.com/voeta.us" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                          <a href="https://youtube.com/@voeta_co?si=NH8N5-UYqJUHbzH9" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
                      </div>
                  </div>

                  {/* Right: Link sections */}
                  <div className="footer-sections-large">
                      <div className="footer-col">
                          <h4>ABOUT</h4>
                          <ul>
                              <li><Link to="/aboutus">About VOETA</Link></li>
                              <li><Link to="/terms">Terms of Use</Link></li>
                              <li><Link to="/privacy">Privacy Policy</Link></li>
                              <li><Link to="/jobs">Jobs</Link></li>
                          </ul>
                      </div>
                      <div className="footer-col">
                          <h4>AGENCIES</h4>
                          <ul>
                              <li><Link to="/travel">Travel Agency</Link></li>
                              <li><Link to="/security">Security Agency</Link></li>
                              <li><Link to="/cleaning">Cleaning Agency</Link></li>
                              <li><Link to="/realestate">Real Estate Agency</Link></li>
                              <li><Link to="/construction">Construction Agency</Link></li>
                          </ul>
                      </div>
                      <div className="footer-col">
                          <h4>CONTACT</h4>
                          <ul>
                              <li><Link to="/contact">Contact Us</Link></li>
                            
                          </ul>
                      </div>
                  </div>
              </div>

              {/* Mobile Layout */}
              <div className="footer-mobile-sections">
                  {['about', 'contact', 'agencies', 'login'].map((section) => (
                      <div key={section} className="mobile-section">
                          <hr className="mobile-divider" />
                          <button onClick={() => toggleSection(section)} className="accordion-toggle">
                              {section.toUpperCase()}
                              <FontAwesomeIcon
                                  icon={faChevronDown}
                                  className={`accordion-icon ${openSection === section ? 'rotate' : ''}`} />
                          </button>
                          {/* Apply specific spring animation for each section */}
                          {section === 'about' && <animated.ul style={aboutSpring}>
                              <li><Link to="/aboutus">About VOETA</Link></li>
                              <li><Link to="/terms">Terms of Use</Link></li>
                              <li><Link to="/privacy">Privacy Policy</Link></li>
                              <li><Link to="/jobs">Jobs</Link></li>
                          </animated.ul>}

                          {section === 'contact' && <animated.ul style={contactSpring}>
                              <li><Link to="/contact">Contact Us</Link></li>
          
                          </animated.ul>}

                          {section === 'agencies' && <animated.ul style={agenciesSpring}>
                              <li><Link to="/travel">Travel Agency</Link></li>
                              <li><Link to="/security">Security Agency</Link></li>
                              <li><Link to="/cleaning">Cleaning Agency</Link></li>
                              <li><Link to="/realestate">Real Estate Agency</Link></li>
                              <li><Link to="/construction">Construction Agency</Link></li>
                          </animated.ul>}

                          {section === 'login' && <animated.ul style={loginSpring}>
                              <li><Link to="/clientportal">Client Portal</Link></li>
                              <li><Link to="/employeeportal">Employee Portal</Link></li>
                          </animated.ul>}
                          {section === 'login' && <hr className="mobile-divider" />}
                      </div>
                  ))}

                  {/* Logo + site text + socials below on small screens */}
                  <div className="footer-brand-mobile">
                      <Link to="/">
                          <img src={logo} alt="Site Logo" className="footer-logo" />
                      </Link>
                      <div className="footer-sitename">Vision Of An Eagle for Trustworthy Agencies</div>
                      <div className="footer-socials">
                          <a href="https://www.tiktok.com/@voeta.co?_t=ZT-8sIVHVs8qM6&_r=1" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
                          <a href="https://facebook.com/voeta.us" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                          <a href="https://youtube.com/@voeta_co?si=NH8N5-UYqJUHbzH9" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
                      </div>
                  </div>
              </div>
          </footer>

          {/* Full-width bottom bar */}
          <div className="footer-bottom-bar">
              <div className="footer-bottom-content">
                  <div className="gtranslate_wrapper"></div>
                  <p>© {new Date().getFullYear()} <span translate="no">VOETA</span>. All rights reserved.</p>
              </div>
          </div>
      </div><style>{`
        /* Full footer container */
.footer-container {
  width: 100vw;
  margin: 0;
  padding: 0;
  background-color: rgb(0, 0, 77);
  box-sizing: border-box;
}

.footer-container .footer-content {
  max-width: 1500px;
  margin: 0 auto;
  padding: 20px;
}

/* Mobile Layout (Default) */
.footer-container .footer-large-layout {
  display: none;
}

.footer-container .footer-mobile-sections {
  display: block;
}

.footer-container .mobile-divider {
  border: none;
  border-top: 1px solid #444;
  padding: 2px;
  margin: 0;
}

/* Accordion Toggle Button */
.footer-container .accordion-toggle {
  width: 100%;
  background: none;
  color: #fff;
  font-size: 15px;
  text-align: left;
  padding: 0;
  margin: 5px 0;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Accordion icon style */
.footer-container .accordion-icon {
  margin-left: 8px;
  font-size: 10px;
  color: #00bfff;
  transition: transform 0.3s ease;
}

.footer-container .accordion-icon.rotate {
  transform: rotate(180deg);
}

/* Mobile section container */
.footer-container .mobile-section {
  margin: 0;
  padding: 0;
}

/* Transition for opening/closing the ul */
.footer-container .mobile-section ul {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: max-height 0.6s ease, opacity 0.6s ease;
}

/* Open state for the ul when section is expanded */
.footer-container .mobile-section ul.open {
  max-height: 9999px;
  opacity: 1;
}

/* Links in mobile section */
.footer-container .mobile-section ul li {
  margin-bottom: 8px;
  text-align: left;
}

.footer-container .mobile-section ul li a {
  color: #aba9a9;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.25s ease;
}

.footer-container .mobile-section ul li a:hover {
  color: #00bfff;
}

/* Mobile Brand Area */
.footer-container .footer-brand-mobile {
  text-align: center;
  margin-top: 40px;
}

.footer-container .footer-logo {
  width: 60px;
  height: auto;
}

.footer-container .footer-sitename {
  margin-top: 10px;
  font-size: 1rem;
  color: #fff;
}

.footer-container .footer-socials {
  margin-top: 10px;
}

.footer-container .footer-socials a {
  color: #ccc;
  margin: 0 8px;
  transition: color 0.3s ease;
}

.footer-container .footer-socials a:hover {
  color: #00bfff;
}

/* Footer Bottom Bar */
.footer-container .footer-bottom {
  margin-top: 20px;
  width: 100%;
  background-color: red;
  border-top: 1px solid #333;
  padding: 10px 20px;
  text-align: center;
  font-size: 0.9rem;
  color: #fff;
}

.footer-container .footer-bottom-bar {
  background-color: red;
  width: 100%;
  padding: 0;
  margin: 0;
}

.footer-container .footer-bottom-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  color: #fff;
  text-align: center;
  font-size: 0.9rem;
  box-sizing: border-box;
}

/* Large Screens */
@media (min-width: 1268px) {
  .footer-container .footer-large-layout {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1px;
  }

  .footer-container .footer-mobile-sections {
    display: none;
  }

  .footer-container .footer-brand-large {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-container .footer-sections-large {
    flex: 2;
    display: flex;
    justify-content: space-between;
  }

  .footer-container .footer-col {
    text-align: left;
  }

  .footer-container .footer-col h4 {
    color: #fff;
    margin-bottom: 12px;
  }

  .footer-container .footer-col ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .footer-container .footer-col ul li {
    margin-bottom: 5px;
  }

  .footer-container .footer-col ul li a {
    color: #ccc;
    text-decoration: none;
    transition: color 0.25s ease;
  }

  .footer-container .footer-col ul li a:hover {
    color: #00bfff;
  }

  .footer-container .footer-logo {
    width: 60px;
  }

  .footer-container .footer-sitename {
    margin-top: 20px;
    font-size: 1rem;
    color: #fff;
  }

  .footer-container .footer-socials {
    margin-top: 15px;
  }

  .footer-container .footer-socials a {
    margin-right: 15px;
  }
}

@media (max-width: 768px) {
  /* Reduce overall font sizes */
  .footer-container .accordion-toggle {
    font-size: 18px;
  }

  .footer-container .mobile-section ul li a {
    font-size: 16px;
  }

  .footer-container .footer-sitename {
    font-size: 0.85rem;
  }

  /* Smaller logo */
  .footer-container .footer-logo {
    width: 45px;
  }

  /* Tighter social icons */
  .footer-container .footer-socials a {
    margin: 0 5px;
    font-size: 16px;
  }

  /* Padding tweaks */
  .footer-container .footer-content {
    padding: 15px;
  }

  .footer-container .footer-bottom-content {
    font-size: 18px;
    padding: 8px 10px;
  }

  /* Smaller accordion chevron */
  .footer-container .accordion-icon {
    font-size: 12px;
  }
}


  `}</style></>
  );
};

export default Footer;
